// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__S5Cfs","title":"ClientInsurance_title__1zDbG","itemText":"ClientInsurance_itemText__SucaA"};